import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type OneloginConnectorConfig = typeof OneloginConnector._.Config;

export const OneloginConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Onelogin,
  logoPath: 'images/onelogin-logo.png',
  categories: [IntegrationConnectorCategory.Identity],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ApiCredentials,
      configSchema: z.object({
        baseUrl: z.url(),
        clientId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
  ]),
});
